var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g, _path37, _g2, _path38, _g3, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _g4, _g5, _g6, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 591,
    viewBox: "0 0 680 591",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.872 463.097C295.122 417.283 220.221 326.007 296.156 284.416C378.562 239.287 483.714 274.838 569.116 226.713C657.604 176.854 616.977 46.6976 680 0V605H0C0 574.989 27.2284 498.422 143.872 463.097Z",
    fill: "#000B3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M526.822 275.06H493.864C490.677 275.06 488.097 272.483 488.097 269.298V236.367C488.097 233.182 490.677 230.605 493.864 230.605H526.822C530.01 230.605 532.589 233.182 532.589 236.367V269.298C532.589 272.483 530.01 275.06 526.822 275.06Z",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M510.343 265.561C503.307 265.561 497.604 259.862 497.604 252.832C497.604 245.802 503.307 240.103 510.343 240.103C517.379 240.103 523.082 245.802 523.082 252.832C523.082 259.862 517.379 265.561 510.343 265.561Z",
    stroke: "#C0CCD8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M501.738 243.84L519.737 261.813",
    stroke: "#C0CCD8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.123 264.942L202.348 255.387H344.372C351.018 255.387 356.402 250.007 356.402 243.367V169.583C356.402 162.942 351.018 157.563 344.372 157.563H201.717C195.072 157.563 189.688 162.942 189.688 169.583V263.558C189.677 265.358 191.873 266.236 193.123 264.942Z",
    fill: "white",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2991 404.498H26.3415C23.1538 404.498 20.5745 401.921 20.5745 398.736V365.805C20.5745 362.62 23.1538 360.043 26.3415 360.043H59.2991C62.4867 360.043 65.0661 362.62 65.0661 365.805V398.736C65.0661 401.921 62.4755 404.498 59.2991 404.498Z",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4703 394.752C28.6393 394.808 28.8195 394.842 28.9997 394.842L56.6183 394.853C57.1928 394.853 57.7334 394.538 58.0263 394.043C58.3191 393.547 58.3191 392.928 58.0263 392.422L44.2282 368.517C43.9354 368.022 43.406 367.707 42.8315 367.707C42.2571 367.707 41.7164 368.011 41.4236 368.517L27.603 392.411C27.3101 392.906 27.3101 393.525 27.603 394.031C27.8057 394.38 28.1099 394.628 28.4703 394.752ZM55.8637 392.793L29.7656 392.782L42.8203 370.206L55.8637 392.793Z",
    fill: "#C0CCD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8202 388.044C43.3383 388.044 43.7776 387.628 43.8001 387.11L44.3633 377.701C44.3971 376.823 43.71 376.103 42.8315 376.103C41.9529 376.103 41.2546 376.835 41.2997 377.701L41.8516 387.11C41.8628 387.639 42.2908 388.044 42.8202 388.044Z",
    fill: "#C0CCD8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8177 390.317C41.8177 390.869 42.2683 391.308 42.809 391.308C43.3609 391.308 43.8002 390.858 43.8002 390.317C43.8002 389.777 43.3496 389.327 42.809 389.327C42.2683 389.327 41.8177 389.766 41.8177 390.317Z",
    fill: "#C0CCD8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M625.413 325.064C625.413 326.448 626.54 327.573 627.925 327.573C629.31 327.573 630.437 326.448 630.437 325.064C630.437 323.679 629.31 322.554 627.925 322.554C626.54 322.554 625.413 323.668 625.413 325.064Z",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M203.734 458.779C203.734 460.163 204.86 461.288 206.245 461.288C207.631 461.288 208.757 460.163 208.757 458.779C208.757 457.394 207.631 456.269 206.245 456.269C204.86 456.269 203.734 457.394 203.734 458.779Z",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2524 252.832C31.2524 254.217 32.3789 255.342 33.7643 255.342C35.1497 255.342 36.2761 254.217 36.2761 252.832C36.2761 251.448 35.1497 250.322 33.7643 250.322C32.3789 250.322 31.2524 251.448 31.2524 252.832Z",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.732 175.266C166.732 176.65 167.859 177.776 169.244 177.776C170.63 177.776 171.756 176.65 171.756 175.266C171.756 173.882 170.63 172.756 169.244 172.756C167.859 172.756 166.732 173.882 166.732 175.266Z",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2761 334.855V342.621",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3901 338.738H40.1621",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M239.451 484.461V492.227",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.565 488.344H243.348",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M403.833 160.939V168.705",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M399.947 164.822H407.719",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M577.824 236.007V243.772",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M573.938 239.89H581.71",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M590.473 414.807V422.573",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M586.587 418.69H594.359",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M149.893 204.91V212.676",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M146.007 208.793H153.779",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M532.645 370.588H610.421C611.784 370.588 612.877 369.485 612.877 368.135C612.877 366.773 611.773 365.681 610.421 365.681H532.645C531.282 365.681 530.19 366.784 530.19 368.135C530.19 369.497 531.294 370.588 532.645 370.588Z",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7078 308.531H152.484C153.847 308.531 154.939 307.428 154.939 306.077C154.939 304.716 153.835 303.624 152.484 303.624H74.7078C73.3449 303.624 72.2523 304.727 72.2523 306.077C72.2411 307.439 73.3449 308.531 74.7078 308.531Z",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3203 325.064H92.0765C92.7523 325.064 93.3043 324.512 93.3043 323.837C93.3043 323.162 92.7523 322.61 92.0765 322.61H63.3203C62.6444 322.61 62.0925 323.162 62.0925 323.837C62.0925 324.512 62.6444 325.064 63.3203 325.064Z",
    fill: "#C0CCD8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M139.407 266.495H168.163C168.839 266.495 169.391 265.944 169.391 265.268C169.391 264.593 168.839 264.042 168.163 264.042H139.407C138.731 264.042 138.179 264.593 138.179 265.268C138.179 265.944 138.731 266.495 139.407 266.495Z",
    fill: "#C0CCD8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M561.559 348.867H583.546C584.222 348.867 584.774 348.316 584.774 347.64C584.774 346.965 584.222 346.414 583.546 346.414H561.548C560.872 346.414 560.32 346.965 560.32 347.64C560.32 348.316 560.872 348.867 561.559 348.867Z",
    fill: "#C0CCD8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M117.645 240.396H93.8337C91.5359 240.396 89.6661 238.528 89.6661 236.232V212.44C89.6661 210.144 91.5359 208.276 93.8337 208.276H117.645C119.943 208.276 121.813 210.144 121.813 212.44V236.232C121.801 238.539 119.943 240.396 117.645 240.396Z",
    stroke: "#C0CCD8",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.178 222.985L101.741 225.743H98.6659V228.196H102.203L103.115 233.024H105.728L104.805 228.196H108.184L109.085 233.024H111.642L110.763 228.196H113.59V225.743H110.29L109.727 222.985H112.723V220.498H109.288L108.375 215.659H105.773L106.686 220.498H103.25L102.327 215.659H99.7697L100.693 220.498H97.8323V222.985H101.178ZM107.733 225.743H104.332L103.768 222.985H107.17L107.733 225.743Z",
    fill: "#C0CCD8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M376.429 462.605L399.013 314.619H500.724L476.349 471.44C474.693 482.064 465.829 489.548 454.881 489.548H283.852L282.591 475.176H361.572C369.164 475.176 375.302 469.977 376.429 462.605Z",
    fill: "#475577"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M472.689 462.605L494.439 320.089C494.934 316.882 497.604 314.608 500.915 314.608H501.118C505.748 314.608 509.543 318.941 508.845 323.443L485.833 471.429C484.178 482.053 475.313 489.537 464.365 489.537H354.217L352.955 475.165H457.843C465.423 475.176 471.562 469.977 472.689 462.605Z",
    fill: "#717A91"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M403.834 489.548V570.322",
    stroke: "#544943",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M449.159 577.457C449.159 573.518 445.96 570.322 442.017 570.322H365.661C361.718 570.322 358.52 573.518 358.52 577.457",
    stroke: "#544943",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M411.65 577.457C411.65 573.518 408.452 570.322 404.509 570.322",
    stroke: "#544943",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M441.95 584.66C441.95 588.644 445.183 591.863 449.159 591.863C453.146 591.863 456.367 588.633 456.367 584.66C456.367 580.676 453.135 577.457 449.159 577.457C445.171 577.457 441.95 580.687 441.95 584.66Z",
    fill: "#717A91"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M446.512 584.66C446.512 586.123 447.694 587.305 449.159 587.305C450.623 587.305 451.806 586.123 451.806 584.66C451.806 583.197 450.623 582.016 449.159 582.016C447.694 582.016 446.512 583.208 446.512 584.66Z",
    fill: "#8E9DB2"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M404.442 584.66C404.442 588.644 407.674 591.863 411.651 591.863C415.638 591.863 418.859 588.633 418.859 584.66C418.859 580.676 415.627 577.457 411.651 577.457C407.663 577.457 404.442 580.687 404.442 584.66Z",
    fill: "#717A91"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M409.004 584.66C409.004 586.123 410.186 587.305 411.651 587.305C413.115 587.305 414.298 586.123 414.298 584.66C414.298 583.197 413.115 582.016 411.651 582.016C410.186 582.016 409.004 583.209 409.004 584.66Z",
    fill: "#8E9DB2"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M351.311 584.66C351.311 588.644 354.544 591.863 358.52 591.863C362.507 591.863 365.728 588.633 365.728 584.66C365.728 580.676 362.496 577.457 358.52 577.457C354.532 577.457 351.311 580.687 351.311 584.66Z",
    fill: "#717A91"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M355.873 584.66C355.873 586.123 357.055 587.305 358.52 587.305C359.984 587.305 361.167 586.123 361.167 584.66C361.167 583.197 359.984 582.016 358.52 582.016C357.055 582.016 355.873 583.208 355.873 584.66Z",
    fill: "#8E9DB2"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M324.345 330.5L298.563 292.02L290.577 293.686C296.682 314.226 300.714 322.351 300.714 322.351",
    fill: "#FFCBBB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M294.688 300.056L290.577 293.686C290.577 293.686 282.929 291.93 280.147 290.512C277.365 289.094 275.517 286.584 274.74 284.457C274.143 282.825 274.402 278.054 275.101 277.975C276.745 277.795 280.023 283.917 281.566 284.277C283.098 284.637 288.088 284.266 290.825 284.626C295.432 285.234 297.38 289.544 297.38 289.544L301.593 297.186",
    fill: "#FFCBBB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M307.495 303.286L302.967 296.736L291.264 301.981L294.981 311.941",
    fill: "#E6E8EF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M401.547 289.567C401.547 289.567 382.455 280.788 365.65 295.734C348.833 310.68 337.456 324.557 331.284 329.059L305.952 299.944L291.805 306.584C295.533 327.663 306.008 361.292 331.622 364.758C359.342 368.506 399.993 334.36 399.993 334.36",
    fill: "#B9B5B2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M339.506 338.738L331.284 329.059",
    stroke: "#846A6A",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M299.013 579.697L301.153 587.924C301.672 589.916 300.162 591.875 298.101 591.875H273.163C271.665 591.875 270.449 590.659 270.449 589.162C270.449 587.98 271.215 586.934 272.341 586.574L289.383 579.697",
    fill: "#173789"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M313.386 451.238C317.373 493.049 299.013 579.697 299.013 579.697C299.013 579.697 294.654 584.964 289.383 579.697C289.383 579.697 284.956 497.078 280.304 459.938",
    fill: "#FFCBBB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M372.87 402.27L344.248 417.272V417.565C344.248 417.565 285.846 413.648 277.004 434.48C263.172 467.107 260.818 573.215 260.818 573.215H303.564C303.564 573.215 319.468 484.09 324.909 478.654C330.349 473.218 352.775 473.623 394.023 473.623C440.35 473.623 417.733 413.941 400.488 408.82",
    fill: "#DE0C4B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M300.613 573.203C300.613 573.203 313.318 481.231 322.656 474.49C334.055 466.252 387.895 471.631 387.895 471.631",
    stroke: "#CE680D",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M388.65 579.697L390.79 587.924C391.308 589.916 389.799 591.875 387.738 591.875H362.8C361.302 591.875 360.085 590.659 360.085 589.162C360.085 587.98 360.851 586.934 361.978 586.574L379.02 579.697",
    fill: "#173789"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M384.494 451.238C388.481 493.049 388.65 579.697 388.65 579.697C388.65 579.697 384.291 584.964 379.019 579.697C379.019 579.697 364.016 497.078 359.353 459.938",
    fill: "#FFCBBB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M423.353 415.392C423.353 415.392 348.281 416.597 338.459 439.331C326.384 467.276 346.287 573.203 346.287 573.203H391.534V478.44C391.534 476.606 392.975 474.951 394.811 475.008C401.074 475.176 415.063 475.176 432.815 475.176C479.143 475.176 456.525 403.136 439.28 398.015",
    fill: "#DE0C4B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M423.353 415.392C423.353 415.392 348.281 416.597 338.459 439.331C335.181 446.905 333.48 459.803 334.359 475.176",
    stroke: "#CE680D",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M385.237 573.203C385.237 573.203 384.775 478.08 386.96 472.993C390.002 465.936 400.376 469.403 424.435 469.403C470.762 469.403 451.884 403.136 434.64 398.015",
    stroke: "#ED841B",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M452.2 426.973C452.2 426.973 428.411 427.547 424.818 423.946C421.225 420.344 424.818 404.025 424.818 404.025",
    stroke: "#ED841B",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M452.786 430.17C452.786 430.17 425.629 430.744 421.518 427.142C417.406 423.541 421.518 407.188 421.518 407.188",
    stroke: "#ED841B",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M457.37 316.375C457.37 316.375 463.069 417.553 454.441 417.553C445.813 417.553 349.88 417.261 344.26 417.261C338.639 417.261 351.795 330.736 370.741 312.459C370.741 312.459 398.844 281.993 411.222 284.908C423.613 287.834 457.37 316.375 457.37 316.375Z",
    fill: "#B9B5B2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M350.342 362.395L362.259 313.607",
    stroke: "#846A6A",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M505.894 334.698L531.677 296.218L539.663 297.884C533.558 318.424 529.525 326.549 529.525 326.549",
    fill: "#FFCBBB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M535.551 304.254L539.663 297.884C539.663 297.884 547.311 296.128 550.093 294.71C552.875 293.292 554.722 290.782 555.499 288.655C556.096 287.023 555.837 282.251 555.139 282.173C553.494 281.993 550.217 288.115 548.674 288.475C547.142 288.835 542.163 288.464 539.415 288.824C534.808 289.432 532.859 293.742 532.859 293.742L528.647 301.384",
    fill: "#FFCBBB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M522.745 307.484L527.273 300.934L538.976 306.179L535.259 316.139",
    fill: "#E6E8EF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M421.912 290.152C421.912 290.152 440.779 276.748 460.253 293.213C478.411 308.553 490.508 339.514 494.563 339.514C497.379 339.514 514.849 317.253 525.279 303.635L537.68 310.264C529.863 334.112 512.821 374.685 487.32 374.685C467.316 374.685 426.226 327.855 426.226 327.855",
    fill: "#B9B5B2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M459.014 359.694L428.602 334.36",
    stroke: "#846A6A",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M420.098 292.538L401.975 311.941L399.598 289.511",
    fill: "#E6E8EF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M420.098 292.538L401.975 311.941L399.598 289.511",
    stroke: "#846A6A",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M405.546 272.944L400.443 284.109C400.443 284.109 398.393 290.501 406.886 293.405C416.201 296.579 421.912 290.141 421.912 290.141L423.252 272.618",
    fill: "#FFCBBB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M422.407 283.771C422.407 283.771 415.694 292.167 406.886 293.416L413.284 302.904C418.465 299.989 424.807 288.667 424.807 288.667L422.407 283.771Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M400.973 282.578C400.973 282.578 402.043 288.577 406.886 293.405L399.598 298.908C397.92 294.789 398.112 288.374 398.112 288.374L400.973 282.578Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M397.988 254.914C397.988 254.914 393.178 273.327 400.398 277.986C407.629 282.645 420.2 275.555 420.921 273.248C421.642 270.941 424.931 251.279 420.211 249.805C411.831 247.182 400.443 247.07 397.988 254.914Z",
    fill: "#FFCBBB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M398.145 260.89C398.021 261.397 398.337 261.903 398.844 262.016C399.351 262.14 399.857 261.825 399.97 261.318C400.094 260.812 399.779 260.305 399.272 260.193C398.765 260.069 398.258 260.384 398.145 260.89Z",
    fill: "#173789"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M399.756 255.409C399.441 255.454 398.022 255.601 398.326 256.299C398.461 256.614 398.956 256.602 399.227 256.58C399.52 256.569 399.812 256.524 400.083 256.614C400.004 256.692 399.948 256.794 399.903 256.895C399.812 257.109 400.511 257.131 400.59 257.131C401.288 257.131 402.122 257.008 402.966 257.57C402.414 255.578 400.263 255.331 399.756 255.409Z",
    fill: "#173789"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M409.724 263.445C409.691 263.963 409.251 264.357 408.733 264.334C408.215 264.301 407.821 263.862 407.843 263.344C407.877 262.826 408.316 262.432 408.835 262.455C409.353 262.477 409.758 262.927 409.724 263.445Z",
    fill: "#173789"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M412.507 259.72C413.182 260.08 413.757 260.575 413.599 261.138C413.475 261.588 413.036 261.476 412.754 261.251C412.293 260.89 411.774 260.609 411.211 260.429C411.459 260.632 411.605 260.958 411.583 261.273C409.826 261.104 408.294 259.585 408.102 257.829C408.114 257.953 409.251 258.651 409.42 258.73C410.423 259.202 411.527 259.191 412.507 259.72Z",
    fill: "#173789"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M402.82 261.993C402.82 261.993 400.252 268.453 401.164 269.016C402.076 269.579 405.298 269.5 405.298 269.5",
    stroke: "#EF977F",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M402.73 279.055C402.73 279.055 410.051 281.88 416.483 276.748",
    stroke: "#EF977F",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M406.886 274.733C406.886 274.733 406.233 271.886 401.547 271.886",
    stroke: "#EF977F",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M393.91 245.033C393.989 244.155 394.124 243.221 394.732 242.591C395.42 241.859 396.535 241.713 397.537 241.701C401.074 241.679 404.6 242.804 407.472 244.864C406.683 244.177 405.906 243.502 405.118 242.816C404.498 242.275 403.101 241.42 403.777 240.407C404.363 239.518 406.041 240.025 406.897 240.013C410.93 239.968 414.816 241.398 418.533 242.827C420.369 243.525 422.205 244.245 423.86 245.292C425.516 246.338 426.992 247.768 427.791 249.557C428.49 251.121 428.625 252.888 428.614 254.599C428.591 257.683 428.107 260.744 427.623 263.794C427.093 267.114 426.293 273.664 421.833 274.069C420.966 274.148 420.02 274.205 419.31 273.687C418.612 273.18 418.375 272.269 418.262 271.413C418.093 270.029 418.195 268.611 418.521 267.26C417.688 267.711 416.888 268.476 415.953 268.33C415.638 268.285 415.323 268.116 415.221 267.823C415.154 267.632 415.176 267.429 415.199 267.227C415.548 264.042 415.739 260.879 415.942 257.683C411.369 256.715 406.773 255.882 402.144 255.184C400.094 254.881 397.92 254.543 396.332 253.215C394.045 251.324 393.662 247.981 393.91 245.033Z",
    fill: "#000B3C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M417.542 268.498C418.296 266.63 419.625 264.368 421.709 265.64C422.441 266.09 422.858 267.047 423.14 267.981C424.097 271.076 421.867 275.848 418.837 275.398C417.361 275.184 416.539 273.428 415.931 271.976",
    fill: "#FFCBBB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M141.4 469.549C141.412 459.521 137.12 449.572 129.821 442.696C126.217 439.308 121.914 436.686 117.273 434.987C114.66 434.019 102.124 433.073 102.124 433.073C102.124 433.073 103.588 442.628 106.077 447.445C111.901 458.677 123.412 468.12 141.4 469.549Z",
    fill: "#1B82F0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M104.545 498.079C100.017 492.531 93.4619 488.659 86.4108 487.365C79.3597 486.071 71.8581 487.365 65.6518 490.944C65.449 491.057 65.235 491.203 65.1787 491.428C65.1111 491.698 65.3026 491.957 65.4941 492.16C71.3174 498.676 80.3509 502.187 89.0465 501.321C92.8649 500.938 100.885 499.261 104.545 498.079Z",
    fill: "#0AB7EF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4757 482.841C94.4644 474.096 91.5584 466.252 86.4221 461.12C81.2859 455.988 73.9644 453.602 66.1587 454.524C65.8996 454.558 65.618 454.603 65.4153 454.84C65.1675 455.121 65.1562 455.515 65.1787 455.841C65.618 466.364 70.9007 475.075 78.9543 478.575C82.4798 480.106 90.5221 482.312 94.4757 482.841Z",
    fill: "#1B82F0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8916 467.197C77.4224 461.615 73.2098 456.505 68.3889 452.048C66.4515 450.259 64.4015 448.548 62.0699 447.299C54.5345 443.259 45.242 444.508 37.1434 447.243C40.3648 453.354 44.5661 459.341 50.7499 462.436C53.487 463.809 56.4831 464.552 59.468 465.216C65.404 466.544 74.8655 466.42 80.8916 467.197Z",
    fill: "#0AB7EF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1943 452.611C100.265 444.722 102.495 428.268 102.878 422.179C103.115 418.364 102.867 414.121 99.6907 411.375C81.0042 417.947 76.2397 430.575 85.1943 452.611Z",
    fill: "#1B82F0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M150.152 450.236C148.981 442.223 147.899 433.614 151.549 426.377C152.855 423.788 154.714 421.504 156.741 419.422C161.641 414.38 168.061 410.215 175.09 410.204C176.352 417.711 174.831 425.657 170.866 432.162C166.913 438.667 160.56 443.686 153.306 446.016",
    fill: "#1B82F0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M106.314 502.649C114.717 499.846 121.858 493.454 125.563 485.407C129.269 477.371 129.506 467.793 126.183 459.589C126.037 459.229 125.845 458.824 125.462 458.7C125.102 458.587 124.73 458.767 124.403 458.959C111.405 466.432 102.518 488.153 106.314 502.649Z",
    fill: "#0AB7EF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M141.648 458.385C144.07 451.373 143.946 443.517 141.288 436.585C138.629 429.663 133.471 423.721 126.983 420.131C124.336 418.668 121.463 417.565 119.109 415.651C118.31 419.174 117.78 422.753 117.51 426.354C117.24 429.911 117.251 433.546 118.197 436.99C120.641 445.892 128.852 451.947 137.098 456.1",
    fill: "#0AB7EF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M152.54 457.034C166.079 458.677 182.738 453.219 189.981 440.479C166.834 428.718 152.54 446.703 152.54 457.034Z",
    fill: "#0AB7EF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M144.633 487.208C147.663 476.82 155.66 468.3 165.279 465.194C174.899 462.076 185.881 464.462 193.664 471.35C193.991 471.631 194.34 472.003 194.306 472.453C194.283 472.723 194.137 472.959 193.991 473.173C188.82 480.646 180.564 485.058 172.128 486.915C163.691 488.772 154.973 488.333 146.379 487.691",
    fill: "#0AB7EF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M162.035 431.835C156.753 437.024 152.923 443.45 149.994 450.214C146.874 457.439 144.61 465.059 142.662 472.667C138.506 488.839 136.14 505.395 134.473 521.984C133.538 531.303 132.919 540.655 131.86 549.963C131.826 550.267 131.364 550.278 131.376 549.963C131.736 541.511 132.491 533.058 133.324 524.64C134.146 516.267 135.115 507.905 136.388 499.587C137.661 491.248 139.238 482.953 141.288 474.76C143.202 467.096 145.433 459.42 148.463 452.116C151.605 444.53 155.75 437.249 161.799 431.599C161.968 431.464 162.193 431.689 162.035 431.835Z",
    fill: "#2170F1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M137.143 495.93C141.13 489.335 147.426 484.833 154.23 481.468C161.765 477.742 169.864 475.131 178.176 473.848C182.738 473.139 187.48 472.667 192.098 473.038C192.357 473.061 192.369 473.443 192.098 473.454C187.919 473.657 183.774 473.781 179.629 474.366C175.619 474.929 171.655 475.795 167.78 476.943C163.826 478.114 159.952 479.566 156.212 481.31C152.765 482.92 149.375 484.72 146.322 487.005C142.898 489.571 140.071 492.711 137.627 496.211C137.424 496.492 136.962 496.234 137.143 495.93Z",
    fill: "#2170F1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M141.243 476.178C141.198 469.954 141.873 463.764 141.321 457.552C140.803 451.767 139.283 445.96 136.805 440.704C135.442 437.8 133.696 435.189 131.86 432.567C131.736 432.387 132.006 432.184 132.153 432.342C134.101 434.379 135.645 436.9 136.906 439.41C138.201 441.964 139.226 444.654 140.037 447.4C141.749 453.208 142.279 459.173 142.144 465.205C142.065 468.863 141.885 472.554 141.49 476.201C141.479 476.347 141.243 476.347 141.243 476.178Z",
    fill: "#2170F1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M172.657 444.823C168.535 445.251 164.75 447.569 161.427 449.91C157.462 452.712 153.858 455.988 150.299 459.274C148.474 460.962 146.694 462.729 144.768 464.305C144.588 464.451 144.34 464.215 144.509 464.046C147.854 460.692 151.448 457.496 155.052 454.434C158.611 451.407 162.385 448.425 166.642 446.432C168.546 445.543 170.551 444.868 172.657 444.711C172.725 444.711 172.725 444.823 172.657 444.823Z",
    fill: "#2170F1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M111.585 522.468C110.38 516.087 108.826 509.863 106.415 503.819C104.027 497.843 100.975 492.126 97.3817 486.78C90.1729 476.099 80.734 466.916 69.7969 460.084C66.7332 458.171 63.5681 456.449 60.2903 454.93C56.9675 453.388 53.5434 452.183 50.1079 450.9C49.7813 450.777 49.9051 450.281 50.2543 450.371C53.3631 451.171 56.4156 452.409 59.3442 453.714C62.3291 455.042 65.2351 456.539 68.051 458.193C73.6491 461.491 78.8867 465.396 83.6625 469.808C93.2367 478.654 100.986 489.515 106.1 501.501C108.927 508.13 111.146 515.22 111.991 522.4C112.025 522.637 111.63 522.693 111.585 522.468Z",
    fill: "#2170F1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2817 424.126C87.2556 436.686 83.6625 451.463 86.4446 465.34C87.2556 469.358 88.6861 473.117 90.4545 476.808C90.6122 477.146 90.1504 477.439 89.9476 477.101C86.1405 470.9 84.7325 463.213 84.71 456.021C84.6875 448.706 86.0842 441.424 88.4158 434.503C89.6435 430.856 91.1416 427.3 92.8875 423.867C93.0114 423.62 93.4056 423.856 93.2817 424.126Z",
    fill: "#2170F1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9641 511.529V524.719C82.9641 577.007 96.7396 591.875 96.7396 591.875H139.395C139.395 591.875 153.171 577.007 153.171 524.719V511.529H82.9641Z",
    fill: "#F2F5F9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M541.037 591.875L504.869 418.566",
    stroke: "#544943",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M468.69 591.875L504.869 418.566",
    stroke: "#544943",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M175.676 591.875L139.497 418.566",
    stroke: "#544943",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M103.329 591.875L139.497 418.566",
    stroke: "#544943",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M107.767 408.19H539.865V418.555H107.767V408.19Z",
    fill: "#E7EAF2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M128.593 388.427H281.296C284.021 388.427 286.083 385.962 285.61 383.283L268.061 284.682C267.509 281.554 264.783 279.28 261.607 279.28H108.904C106.179 279.28 104.117 281.745 104.59 284.424L122.139 383.024C122.702 386.153 125.417 388.427 128.593 388.427Z",
    fill: "#475577"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M125.045 388.427H277.747C280.473 388.427 282.534 385.962 282.061 383.283L264.513 284.682C263.961 281.554 261.235 279.28 258.058 279.28H105.356C102.63 279.28 100.569 281.745 101.042 284.424L118.591 383.024C119.154 386.153 121.869 388.427 125.045 388.427Z",
    fill: "#C0CCD8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M153.137 388.427H241.332C242.909 388.427 244.091 387.009 243.821 385.455L233.684 328.508C233.357 326.707 231.792 325.39 229.956 325.39H141.761C140.184 325.39 139.001 326.808 139.271 328.361L149.409 385.309C149.735 387.121 151.301 388.427 153.137 388.427Z",
    fill: "#8E9DB2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M151.031 388.427H239.226C240.802 388.427 241.985 387.009 241.715 385.455L231.577 328.508C231.251 326.707 229.685 325.39 227.849 325.39H139.654C138.077 325.39 136.895 326.808 137.165 328.361L147.302 385.309C147.629 387.121 149.195 388.427 151.031 388.427Z",
    fill: "#C6D2E0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M170.573 354.933H206.369V388.427H170.573V354.933Z",
    fill: "#8E9DB2"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M172.623 354.933H206.369V364.556L197.156 402.754H161.337L172.623 354.933ZM181.285 392.568C185.295 392.568 189.541 387.898 190.758 382.124C191.974 376.362 189.71 371.68 185.7 371.68C181.691 371.68 177.444 376.351 176.228 382.124C175.011 387.898 177.275 392.568 181.285 392.568Z",
    fill: "#475577"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M226.115 402.754H145.94V408.19H231.566C231.555 405.196 229.122 402.754 226.115 402.754Z",
    fill: "#475577"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M145.928 402.754H210.03V408.19H145.928V402.754Z",
    fill: "#C0CCD8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M170.551 354.933H206.369L195.083 402.754H159.264L170.551 354.933ZM179.348 392.568C183.358 392.568 187.604 387.898 188.82 382.124C190.037 376.362 187.773 371.68 183.763 371.68C179.753 371.68 175.507 376.351 174.29 382.124C173.074 387.886 175.338 392.568 179.348 392.568Z",
    fill: "#C0CCD8"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M254.184 288.993L256.313 300.923H254.184L252.066 288.993H254.184Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M248.045 288.993L250.174 300.923H248.045L245.927 288.993H248.045Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M241.906 288.993L244.035 300.923H241.906L239.789 288.993H241.906Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M235.768 288.993L237.897 300.923H235.768L233.65 288.993H235.768Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M229.629 288.993L231.758 300.923H229.629L227.511 288.993H229.629Z",
    fill: "#8E9DB2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M173.614 288.993L175.743 300.923H173.614L171.497 288.993H173.614Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M167.172 288.993L169.289 300.923H167.172L165.043 288.993H167.172Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M160.717 288.993L162.835 300.923H160.717L158.6 288.993H160.717Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M154.263 288.993L156.392 300.923H154.263L152.146 288.993H154.263Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M147.821 288.993L149.938 300.923H147.821L145.692 288.993H147.821Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M141.366 288.993L143.484 300.923H141.366L139.249 288.993H141.366Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M134.912 288.993L137.041 300.923H134.912L132.795 288.993H134.912Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M128.469 288.993L130.587 300.923H128.469L126.341 288.993H128.469Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M122.015 288.993L124.133 300.923H122.015L119.898 288.993H122.015Z",
    fill: "#8E9DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M115.561 288.993L117.679 300.923H115.561L113.444 288.993H115.561Z",
    fill: "#8E9DB2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M418.15 381.179C418.15 381.179 417.159 380.999 416.753 380.436C415.92 379.277 417.305 378.05 418.206 377.465C419.366 376.722 420.954 376.474 421.518 375.056C422.148 373.458 421.056 371.68 419.738 370.802C418.623 370.071 417.316 369.699 416.066 369.226C414.669 368.709 413.261 367.865 412.45 366.559C411.437 364.927 411.639 362.834 411.504 360.999C410.986 353.819 403.631 350.251 397.447 350.105C394.349 350.026 389.619 351.14 387.569 353.538C386.882 354.348 386.352 355.305 386.161 356.351C385.857 357.972 386.487 359.469 387.535 360.673C388.594 361.889 390.058 362.598 391.218 363.689C392.423 364.815 391.567 366.008 391.838 367.358C392.142 368.855 393.144 369.497 394.451 370.217C397.199 371.747 400.432 372.13 403.417 372.963C404.352 373.222 405.287 373.537 406.041 374.145C407.021 374.932 407.573 376.103 408.305 377.116C409.657 378.95 411.696 380.267 413.926 380.717",
    fill: "url(#paint0_linear)"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M400.939 399.253H406.807V396.451H400.939C399.046 396.451 397.503 394.909 397.503 393.019V388.202C397.503 386.311 399.046 384.769 400.939 384.769H406.807V381.967H400.939C397.503 381.967 394.71 384.758 394.71 388.19V393.007C394.699 396.462 397.503 399.253 400.939 399.253Z",
    fill: "#E8EAEF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M409.296 406.625H419.197C423.004 406.625 426.091 403.541 426.091 399.737V378.027H402.392V399.737C402.403 403.53 405.489 406.625 409.296 406.625Z",
    fill: "#E8EAEF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M429.932 402.63C429.932 402.63 429.706 408.201 421.044 408.201H407.46C398.799 408.201 398.573 402.63 398.573 402.63H429.932Z",
    fill: "#C6D2E0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M239.53 405.972H364.872V408.201H239.53V405.972Z",
    fill: "#475577"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M351.615 404.172H360.592V405.972H351.615V404.172Z",
    fill: "#475577"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M338.02 404.172H346.997V405.972H338.02V404.172Z",
    fill: "#475577"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M324.424 404.172H333.401V405.972H324.424V404.172Z",
    fill: "#475577"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M310.829 404.172H319.806V405.972H310.829V404.172Z",
    fill: "#475577"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M297.222 404.172H306.2V405.972H297.222V404.172Z",
    fill: "#475577"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M283.627 404.172H292.604V405.972H283.627V404.172Z",
    fill: "#475577"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M270.032 404.172H279.009V405.972H270.032V404.172Z",
    fill: "#475577"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M256.437 404.172H265.414V405.972H256.437V404.172Z",
    fill: "#475577"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M242.841 404.172H251.818V405.972H242.841V404.172Z",
    fill: "#475577"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M237.896 405.972H363.239V408.201H237.896V405.972Z",
    fill: "#C0CCD8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M349.97 404.172H358.948V405.972H349.97V404.172Z",
    fill: "#C0CCD8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M336.375 404.172H345.352V405.972H336.375V404.172Z",
    fill: "#C0CCD8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M322.78 404.172H331.757V405.972H322.78V404.172Z",
    fill: "#C0CCD8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M309.184 404.172H318.162V405.972H309.184V404.172Z",
    fill: "#C0CCD8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M295.589 404.172H304.566V405.972H295.589V404.172Z",
    fill: "#C0CCD8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M281.994 404.172H290.971V405.972H281.994V404.172Z",
    fill: "#C0CCD8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M268.398 404.172H277.376V405.972H268.398V404.172Z",
    fill: "#C0CCD8"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M254.792 404.172H263.769V405.972H254.792V404.172Z",
    fill: "#C0CCD8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M241.197 404.172H250.174V405.972H241.197V404.172Z",
    fill: "#C0CCD8"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M541.589 492.205C540.034 486.026 540.721 479.307 543.504 473.578C546.286 467.85 551.14 463.145 556.964 460.557C559.34 459.499 561.886 458.767 564.026 457.304C564.443 460.377 564.634 463.483 564.6 466.578C564.567 469.651 564.296 472.757 563.226 475.627C560.478 483.066 552.999 487.635 545.632 490.584",
    fill: "#1B82F0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M540.688 512.148C540.541 506.498 540.631 500.769 541.059 495.142C541.251 492.666 541.51 490.156 542.141 487.737C542.907 484.799 544.01 481.907 545.373 479.194C546.939 476.077 548.944 472.926 551.602 470.607C551.782 470.45 552.03 470.686 551.872 470.877C549.868 473.286 547.998 475.717 546.5 478.485C545.002 481.265 543.853 484.225 542.974 487.264C541.487 492.396 541.465 497.933 541.307 503.234C541.217 506.205 541.24 509.188 540.958 512.148C540.935 512.305 540.699 512.316 540.688 512.148Z",
    fill: "#2170F1"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M559.104 531.021C560.185 522.479 564.927 514.466 571.899 509.401C575.335 506.903 579.288 505.147 583.433 504.191C585.765 503.65 596.544 504.213 596.544 504.213C596.544 504.213 594.258 512.193 591.611 516.03C585.427 524.966 574.591 531.753 559.104 531.021Z",
    fill: "#1B82F0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M568.531 503.515C568.813 498.35 569.759 493.217 571.347 488.311C571.989 486.341 572.733 484.383 573.837 482.638C577.396 476.988 584.053 474.355 590.462 473.196C590.541 478.643 589.921 484.371 586.914 488.851C585.585 490.832 583.85 492.475 582.104 494.062C578.635 497.213 572.271 500.702 568.531 503.515Z",
    fill: "#0AB7EF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M532.15 484.687C533.152 477.799 534.087 470.405 530.944 464.192C529.818 461.964 528.219 460.005 526.484 458.216C522.271 453.883 516.763 450.304 510.726 450.293C509.645 456.742 510.951 463.562 514.353 469.155C517.743 474.76 525.921 482.683 532.15 484.687Z",
    fill: "#0AB7EF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M543.211 524.685C536.802 526.013 529.874 524.584 524.513 520.825C519.151 517.066 515.457 511.045 514.522 504.573C514.477 504.292 514.454 503.954 514.646 503.74C514.826 503.538 515.142 503.515 515.412 503.515C526.507 503.459 540.248 514.027 543.211 524.685Z",
    fill: "#0AB7EF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M565.997 499.79C556.873 494.658 551.005 484.371 550.836 473.207C557.425 472.847 562.381 476.887 565.254 480.387C569.252 485.249 569.59 493.78 565.997 499.79Z",
    fill: "#0AB7EF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M559.374 517.831C561.807 511.765 561.041 504.517 557.392 499.092C553.742 493.668 547.311 490.224 540.766 490.201C540.496 490.201 540.181 490.224 540.023 490.449C539.933 490.584 539.922 490.753 539.91 490.91C539.663 496.515 542.129 501.974 545.666 506.329C549.203 510.685 553.754 514.083 558.315 517.336",
    fill: "#0AB7EF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M522.147 468.671C526.811 473.016 530.178 478.497 532.769 484.293C535.495 490.393 537.455 496.83 539.167 503.279C542.861 517.223 544.9 531.562 546.387 545.889C547.22 554.014 547.998 562.196 548.302 570.356C548.313 570.671 547.851 570.66 547.817 570.356C546.961 563.198 546.488 555.984 545.79 548.803C545.103 541.668 544.292 534.544 543.222 527.465C542.163 520.453 540.856 513.476 539.167 506.577C537.556 499.97 535.686 493.386 533.197 487.05C530.584 480.387 527.047 473.972 521.911 468.896C521.765 468.75 521.99 468.525 522.147 468.671Z",
    fill: "#2170F1"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M559.385 527.476C559.374 526.216 559.498 524.955 559.453 523.695C559.408 522.254 559.284 520.802 559.081 519.373C558.89 518.022 558.642 516.683 558.327 515.355C558.045 514.162 557.561 512.958 557.392 511.731C557.358 511.506 557.673 511.484 557.775 511.63C558.484 512.654 558.766 514.072 559.059 515.265C559.385 516.627 559.622 518.011 559.813 519.395C560.005 520.825 560.117 522.265 560.151 523.706C560.185 524.966 560.219 526.328 559.915 527.566C559.847 527.848 559.385 527.78 559.385 527.476Z",
    fill: "#2170F1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M558.619 480.928C561.345 483.302 563.001 486.769 564.127 490.156C565.501 494.309 566.144 498.755 565.986 503.121C565.896 505.541 565.614 508.062 564.803 510.358C564.724 510.572 564.398 510.493 564.454 510.257C565.434 506.036 565.806 501.85 565.333 497.528C564.882 493.443 563.812 489.323 561.92 485.666C561.041 483.966 559.948 482.334 558.541 481.018C558.484 480.961 558.563 480.883 558.619 480.928Z",
    fill: "#2170F1"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M555.961 559.191C555.803 554.375 556.209 549.501 556.693 544.718C557.2 539.699 557.955 534.702 558.991 529.772C561.097 519.744 564.353 509.852 569.342 500.871C570.717 498.395 572.215 495.997 573.859 493.701C575.492 491.417 577.25 489.076 579.311 487.151C579.57 486.904 579.908 487.264 579.694 487.534C578.094 489.515 576.416 491.406 574.918 493.465C573.442 495.491 572.068 497.595 570.807 499.756C568.227 504.168 566.087 508.816 564.308 513.599C560.782 523.076 558.653 533.047 557.493 543.064C556.874 548.432 556.705 553.801 556.4 559.191C556.378 559.462 555.972 559.462 555.961 559.191Z",
    fill: "#2170F1"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M518.701 537.065V546.057C518.701 581.723 530.539 591.863 530.539 591.863H567.18C567.18 591.863 579.018 581.723 579.018 546.057V537.065H518.701Z",
    fill: "#F2F5F9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M241.895 234.161C242.267 234.285 242.65 234.352 243.055 234.364L303.035 234.386C304.285 234.386 305.456 233.711 306.087 232.63C306.718 231.55 306.718 230.199 306.087 229.119L276.114 177.202C275.495 176.121 274.335 175.446 273.073 175.446C271.823 175.446 270.651 176.121 270.032 177.202L240.025 229.096C239.395 230.177 239.395 231.527 240.025 232.608C240.431 233.339 241.107 233.891 241.895 234.161ZM301.379 229.918L244.7 229.896L273.062 180.86L301.379 229.918Z",
    fill: "#DE0C4B"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M273.039 219.598C274.177 219.598 275.112 218.709 275.157 217.572L276.373 197.145C276.463 195.254 274.943 193.667 273.05 193.667C271.147 193.667 269.638 195.254 269.716 197.145L270.922 217.572C270.978 218.697 271.913 219.598 273.039 219.598Z",
    fill: "#DE0C4B"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M270.877 224.527C270.877 225.72 271.845 226.688 273.039 226.688C274.233 226.688 275.202 225.72 275.202 224.527C275.202 223.334 274.233 222.366 273.039 222.366C271.845 222.366 270.877 223.334 270.877 224.527Z",
    fill: "#DE0C4B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 403.878,
    y1: 381.176,
    x2: 403.878,
    y2: 350.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.a3f0ece8270ee1c9c201a6de1df6b3ab.svg";
export { ForwardRef as ReactComponent };